import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    ButtonGroup,
    Badge,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Container,
    Row,
    Form,
    Col,
    Table,
    TabContent,
    TabPane,
    Modal,
} from "reactstrap";
import { Spinner } from "reactstrap";
// core components
import NumberFormat from 'react-number-format';
import PointOfSalesHeader from "components/Headers/PointOfSalesHeader";
import Products from "components/Tables/Product.js";
import ProductDataService from "../../services/ProductDataService";
import DeductDataService from "../../services/DeductDataService";
import CreditDataService from "../../services/CreditDataService";
import CreditCategoryDataService from "../../services/CreditCategoryDataService";
import SettingDataService from "../../services/SettingDataService";
import CashierDataService from "../../services/CashierDataService";

// The grouping separator toLocaleString() emits depends on the machine's locale
// ("100,000" on en-US, "100.000" on id-ID, "100\u00a0000" on fr-FR), so stripping
// commas only round-trips on en-US. Keep digits instead, and pin the format
// locale so what we emit is always what parseAmount() can read back.
function parseAmount(value) {
    let digits = String(value === undefined || value === null ? '' : value).replace(/[^0-9]/g, '');
    return digits === '' ? 0 : Number(digits);
}

function formatAmount(value) {
    return Number(value).toLocaleString('en-US');
}

class PointOfSales extends React.Component {
    constructor(props) {
        super(props);
        this.resetState();
        this.ProductDataService = new ProductDataService();
        this.deductDataService = new DeductDataService();
        this.CreditDataService = new CreditDataService();
        this.creditCategoryDataService = new CreditCategoryDataService();
        this.settingDataService = new SettingDataService();
        this.cashierDataService = new CashierDataService();
    }

    componentDidMount() {
        this.creditCategoryDataService.getList()
            .then(res => this.setState(res));

        this.settingDataService.getList()
            .then(res => this.setState({ settings: res.data }));

        this.fetchEmoneyProducts();
        this.fetchCashierStatus();
    }

    isCashier() {
        return (localStorage.getItem('user_roles') || '')
            .split(',')
            .map((role) => role.trim().toLowerCase())
            .includes('cashier');
    }

    fetchCashierStatus() {
        this.setState({ cashierLoading: true });
        this.cashierDataService.getStatus()
            .then((res) => {
                this.setState({
                    cashierIsOpen: res.isOpen,
                    cashierIsSessionOwner: res.isSessionOwner,
                    cashierSession: res.session,
                    cashierErrorMessage: res.errorMessage,
                });
            })
            .catch(() => {
                this.setState({ cashierErrorMessage: 'Gagal memuat status kasir.' });
            })
            .finally(() => {
                this.setState({ cashierLoading: false });
            });
    }

    // The action is the opposite of the status reported by GET /cashier/status.
    handleCashierStatusChange() {
        if (this.state.cashierActionLoading || this.state.cashierLoading) {
            return;
        }
        const status = this.state.cashierIsOpen ? 'close' : 'open';
        this.setState({ cashierActionLoading: true, cashierErrorMessage: undefined });

        this.cashierDataService.setStatus(status)
            .then((res) => {
                if (res.errorMessage) {
                    this.setState({ cashierErrorMessage: res.errorMessage });
                    return;
                }
                if (status === 'close') {
                    this.setState({
                        cashierSummary: res.session,
                        cashierSummaryModal: true,
                    });
                }
                this.fetchCashierStatus();
            })
            .catch(() => {
                this.setState({ cashierErrorMessage: 'Gagal mengubah status kasir.' });
            })
            .finally(() => {
                this.setState({ cashierActionLoading: false });
            });
    }

    toggleCashierSummaryModal = () => {
        this.setState({ cashierSummaryModal: !this.state.cashierSummaryModal });
    }

    formatSessionTime(value) {
        if (!value) {
            return '-';
        }
        return new Date(value).toLocaleString('id-ID', {
            day: '2-digit',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit',
        });
    }

    fetchEmoneyProducts() {
        this.setState({ emoneyLoading: true, emoneyError: undefined });
        this.ProductDataService
            .getList('', -1, 1, 100, 0, true)
            .then(res => {
                if (res && res.products) {
                    this.setState({ emoneyProducts: res.products });
                } else {
                    this.setState({ emoneyProducts: [] });
                }
            })
            .catch(() => {
                this.setState({ emoneyError: 'Gagal memuat produk E-Money.' });
            })
            .finally(() => {
                this.setState({ emoneyLoading: false });
            });
    }

    handleEmoneyCardClick(emoneyId) {
        const selectedEmoney = this.state.emoneyProducts.find(product => product.product_id === emoneyId);

        this.setState({
            selectedEmoneyId: emoneyId,
            selectedEmoney: selectedEmoney,
            emoneyPriceModal: true,
            emoneyPrice: '',
            emoneyOriginalPrice: ''
        });
    }

    toggleEmoneyPriceModal = () => {
        this.setState({ emoneyPriceModal: !this.state.emoneyPriceModal });
    }

    handleEmoneyPriceChange = (e) => {
        let price = e.target.value;
        if (price.length > 21) {
            this.setErrormessage('Input angka melebihi batas maksimal sistem.');
        } else {
            price = price.replace(/,/g, '');
            price = Number(price).toLocaleString();
            this.setState({ emoneyPrice: price });
        }
    }

    handleEmoneyOriginalPriceChange = (e) => {
        let price = e.target.value;
        if (price.length > 21) {
            this.setErrormessage('Input angka melebihi batas maksimal sistem.');
        } else {
            price = price.replace(/,/g, '');
            price = Number(price).toLocaleString();
            this.setState({ emoneyOriginalPrice: price });
        }
    }

    handleEmoneyPriceSubmit = () => {
        if (!this.state.selectedEmoney || !this.state.emoneyPrice) {
            this.setErrormessage('Harga tidak boleh kosong.');
            return;
        }

        const price = Number(this.state.emoneyPrice.replace(/,/g, ''));
        const originalPrice = this.state.emoneyOriginalPrice ? Number(this.state.emoneyOriginalPrice.replace(/,/g, '')) : 0;

        if (price <= 0) {
            this.setErrormessage('Harga harus lebih dari 0.');
            return;
        }

        const emoneyProduct = {
            // Keep original product id for backend processing
            product_id: this.state.selectedEmoney.product_id,
            product_name: this.state.selectedEmoney.product_name,
            sell_price: price,
            original_sell_price: price,
            final_sell_price: price,
            discount_per_qty: '0',
            product_stock: 1,
            product_price: price,
            original_price: originalPrice,
            // Mark this line item as e-money type so backend receives product_type = 'eproduct'
            product_type: 'eproduct'
        };

        // IMPORTANT: Append E-Money as a new line item instead of overwriting by product_id
        // This allows the same E-Money to be added multiple times with different prices
        let currentDeductCandidates = this.state.deductCandidates;
        currentDeductCandidates = Array.isArray(currentDeductCandidates)
            ? currentDeductCandidates.slice()
            : [];
        currentDeductCandidates.push(emoneyProduct);

        this.updateCandidateDetails(currentDeductCandidates);

        this.toggleEmoneyPriceModal();
    }

    resetState() {
        this.state = {
            defaultModal: false,
            settings: [],
            cashErrorMessage: undefined,
            emoneyPriceModal: false,
            emoneyOriginalPrice: '',
            products: [],
            perPage: 100,
            currentPage: 1,
            currentProduct: {},
            deductCandidates: [],
            stockInputs: {},
            subtotal: 0,
            nikRequired: false,
            tabs: 1,
            creditValidated: false,
            creditApproved: false,
            success: false,
            paymentMethod: 1,
            currentCheckout: undefined,
            checkoutDisabled: false,
            searchId: 'barcode',
            emoneyProducts: [],
            emoneyLoading: false,
            emoneyError: undefined,
            selectedEmoneyId: null,
            selectedEmoney: null,
            emoneyPrice: '',
            creditActionLoading: false,
            emoneyCardOpen: false,
            cashierLoading: false,
            cashierIsOpen: false,
            cashierIsSessionOwner: false,
            cashierSession: undefined,
            cashierActionLoading: false,
            cashierSummary: undefined,
            cashierSummaryModal: false,
            cashierErrorMessage: undefined,
        };
    }

    toggleNavs = (e, state, index) => {
        e.preventDefault();
        this.setState({
            [state]: index,
            products: [],
            currentProduct: {},
            deductCandidates: [],
            stockInputs: {},
            nik: undefined,
            subtotal: 0,
            nikRequired: false,
            paymentMethod: '0',
            searchValue: '',
        });
    };

    toggleModal = (state, formType, checkout) => {
        this.setState({
            [state]: !this.state[state],
            formType: formType,
            // currentCheckout: checkout,
        });
    };

    toggleEmoneyCard = () => {
        this.setState({ emoneyCardOpen: !this.state.emoneyCardOpen });
    }

    handleSearch = (e) => {
        const keyword = e.target.value;
        this.setState({ [e.target.name]: keyword, currentCheckout: undefined });
        this.fetchData(keyword);
    }

    setSearchId = (mode) => {
        if (mode === this.state.searchId) {
            return;
        }
        this.setState({ searchId: mode }, () => this.fetchData(this.state.searchValue));
    }

    fetchData(keyword) {
        if (keyword === undefined || keyword === '') {
            this.setState({ products: [] });
        } else if (this.state.searchId == 'nama') {
            this.ProductDataService.getList(keyword, undefined, this.state.currentPage, this.state.perPage)
                .then(res => this.setState(res))
                .then((data) => {
                    let newCandidate = this.deductStockPostSearch(this.getNewCandidate());
                    this.setState({ products: [newCandidate] });
                });
            setTimeout(() => {
                this.setState({ errorMessage: undefined })
            }, 5000);
        } else {
            this.ProductDataService.getByBarcode(keyword, this.state.currentPage, this.state.perPage)
                .then(res => this.setState(res))
                .then((data) => {
                    let newCandidate = this.deductStockPostSearch(this.getNewCandidate());
                    this.setState({ products: [newCandidate] });
                });
            setTimeout(() => {
                this.setState({ errorMessage: undefined })
            }, 5000);
        }
    }

    handlePageClick = (e) => {
        const selectedPage = e;

        this.setState({
            currentPage: selectedPage,
        }, () => {
            this.fetchData()
        });
    }

    handleNextPageClick() {
        this.handlePageClick(this.state.currentPage + 1)
    }

    handlePreviousPageClick() {
        this.handlePageClick(this.state.currentPage - 1)
    }

    setSuccessMessage = (message) => {
        this.setState({ successMessage: message })
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            if (e.target.name === 'searchValue' && (e.target.value !== undefined && e.target.value !== '')) {
                let newCandidate = this.getNewCandidate();
                this.addToCart(newCandidate);
            } else {
                this.handleCheckout();
            }
        }
    }

    onKeyUpKredit(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            if (!this.state.creditActionLoading) {
                this.handlePreSubmitCredit();
            }
        }
    }

    addToCart(newCandidate) {
        if (newCandidate !== undefined) {
            if (this.deductStock(newCandidate)) {
                this.handleAddToCandidate(newCandidate);
                this.setState({ searchValue: '', products: [] })
            }
        } else {
            this.setErrormessage('Barcode produk tidak terdaftar.', false);
        }
    }

    getNewCandidate() {
        return this.state.products[0];
    }

    handleAddToCandidate(newCandidate) {
        let currentDeductCandidates = this.updateCurrentCandidates(this.state.deductCandidates, newCandidate);
        this.updateCandidateDetails(currentDeductCandidates);
    }

    updateCandidateDetails(currentDeductCandidates) {
        let subtotal = this.updateSubtotal(currentDeductCandidates);
        let cashChange = this.recalculateCashChange(subtotal);
        this.setState({
            deductCandidates: currentDeductCandidates,
            subtotal: subtotal,
            cashChange: cashChange,
        })
        if (cashChange !== undefined && cashChange < 0) {
            this.setCashErrormessage('Uang cash kurang.');
        }
    }

    recalculateCashChange(subtotal) {
        if (this.state.cashMoney === undefined || this.state.cashMoney === '') {
            return undefined;
        }
        return parseAmount(this.state.cashMoney) - subtotal;
    }

    updateCurrentCandidates(currentDeductCandidates, newCandidate) {
        if (currentDeductCandidates[newCandidate.product_id] !== undefined) {
            let discountPerQty = Number(currentDeductCandidates[newCandidate.product_id].discount_per_qty.replace(/,/g, ''))

            currentDeductCandidates[newCandidate.product_id].product_stock++;
            currentDeductCandidates[newCandidate.product_id].sell_price =
                newCandidate.sell_price * currentDeductCandidates[newCandidate.product_id].product_stock;
            currentDeductCandidates[newCandidate.product_id].final_sell_price =
                ((newCandidate.sell_price - discountPerQty)
                    * currentDeductCandidates[newCandidate.product_id].product_stock);
        } else {
            currentDeductCandidates[newCandidate.product_id] = {
                product_id: newCandidate.product_id,
                product_name: newCandidate.product_name,
                sell_price: newCandidate.sell_price,
                original_sell_price: newCandidate.sell_price,
                final_sell_price: newCandidate.sell_price,
                discount_per_qty: '0',
                product_stock: 1,
                product_price: newCandidate.product_price !== undefined
                    ? newCandidate.product_price
                    : (newCandidate.original_price !== undefined ? newCandidate.original_price : undefined),
                original_price: newCandidate.original_price,
            };
        }
        return currentDeductCandidates;
    }

    updateSubtotal(currentDeductCandidates) {
        let currentSubtotal = 0;
        currentDeductCandidates.map((candidate) => {
            return currentSubtotal += candidate.final_sell_price;
        })
        return currentSubtotal;
    }

    // Live, uncommitted preview of a row's qty while the user is still typing it,
    // so totals track the input directly without waiting for the stock-checked commit.
    getEffectiveProductStock(product) {
        let raw = this.state.stockInputs[product.product_id];
        if (raw === undefined) {
            return product.product_stock;
        }
        let parsed = parseInt(raw, 10);
        return isNaN(parsed) || parsed < 0 ? product.product_stock : parsed;
    }

    getEffectiveFinalSellPrice(product) {
        let effectiveStock = this.getEffectiveProductStock(product);
        if (effectiveStock === product.product_stock) {
            return product.final_sell_price;
        }
        let discountPerQty = Number(product.discount_per_qty.replace(/,/g, ''));
        return (product.original_sell_price - discountPerQty) * effectiveStock;
    }

    getDisplaySubtotal() {
        if (!Array.isArray(this.state.deductCandidates)) {
            return this.state.subtotal;
        }
        let total = 0;
        this.state.deductCandidates.forEach((product) => {
            if (product) {
                total += this.getEffectiveFinalSellPrice(product);
            }
        });
        return total;
    }

    getDisplayCashChange() {
        return this.recalculateCashChange(this.getDisplaySubtotal());
    }

    // paymentMethod arrives from the <select> as a string, so compare numerically.
    isCashShort() {
        if (Number(this.state.paymentMethod) === 2) {
            return false;
        }
        let cashChange = this.getDisplayCashChange();
        // undefined means nothing tendered yet; checkout validation reports that itself.
        return cashChange !== undefined && cashChange < 0;
    }

    getPotentialLoyaltyPoints() {
        let multiplierSetting = this.state.settings?.find((setting) => setting.key === 'loyalty_point_purchase_multiplier');
        let multiplier = Number(multiplierSetting?.value);
        let subtotal = this.getDisplaySubtotal();
        if (!multiplier || !subtotal) {
            return 0;
        }
        return Math.floor(subtotal / multiplier);
    }

    /**
     * Sync current stock retrieved from server with current stock to be deducted on cart.
     * @param {*} newCandidate
     * @returns
     */
    deductStockPostSearch(newCandidate) {
        if (newCandidate !== undefined) {
            let existingCandidate = this.state.deductCandidates[newCandidate.product_id];
            if (existingCandidate !== undefined) {
                newCandidate.stock_warehouse -= existingCandidate.product_stock
            }
        }
        return newCandidate;
    }

    deductStock(newCandidate) {
        if (newCandidate.stock_warehouse === 0) {
            this.setErrormessage('Stok tidak tersedia lagi.', false);
            return false;
        }

        newCandidate.stock_warehouse--;
        this.setState({ products: [newCandidate] });
        return true;
    }

    cancelDeductStock(product) {
        let currentDeductCandidates = this.state.deductCandidates;
        let existingCandidate = currentDeductCandidates[product.product_id];
        let discountPerQty = Number(product.discount_per_qty.replace(/,/g, ''));

        existingCandidate.product_stock--;
        existingCandidate.sell_price -= product.original_sell_price;
        existingCandidate.final_sell_price = product.sell_price - discountPerQty;
        if (existingCandidate.product_stock === 0) {
            delete currentDeductCandidates[product.product_id];
        }
        this.updateCandidateDetails(currentDeductCandidates)
    }

    handleInputChanged(e) {
        let type = e.target.type
        let nam = e.target.name
        let val = type === 'number' || type === 'select-one' || nam === 'nik' ? Number(e.target.value) : e.target.value
        let updateState = true;
        if (type === 'checkbox') {
            val = e.target.checked;
        }
        if (nam === 'paymentMethod') {
            let nikRequired = val === 2 ? true : false;
            this.setState({ nikRequired: nikRequired });
        } else if (nam === 'amount' || nam === 'total_kredit') {
            if (val.length > 21) {
                this.setErrormessage('Input angka melebihi batas maksimal sistem.')
            } else {
                val = val.replace(/,/g, '');
                val = Number(val).toLocaleString();
            }
        } else if (nam === 'nik') {
            // Look up with the raw input: Number() would drop leading zeros.
            this.handlePopulateNamaKaryawan(e.target.value);
        }

        if (updateState) {
            this.setState({ [nam]: val, creditValidated: false })
        }
    }

    handlePopulateNamaKaryawan(nik) {
        const keyword = String(nik ?? '').trim();
        this.lastNikLookup = keyword;

        if (keyword === '') {
            this.setState({ namaKaryawan: undefined });
            return;
        }

        this.CreditDataService.getCreditByNIK(keyword)
            .then((res) => {
                // Fires on every keystroke, so ignore responses for an older NIK.
                if (this.lastNikLookup !== keyword) {
                    return;
                }
                this.setState({ namaKaryawan: res.data?.nama })
            })
    }

    handleCheckout() {
        if (this.handleCheckoutValidation()) {
            this.deductDataService.deduct(
                this.state.deductCandidates,
                this.state.paymentMethod,
                this.state.nik,
            ).then((res) => {
                if (res.data?.errorMessage) {
                    this.setState({ errorMessage: res.data.errorMessage });
                } else if (res.header.message === 'Success' || res.header.status_code === 200) {
                    this.setSuccessMessage('Checkout berhasil.')

                    // checkout receipt purposes
                    this.setState({
                        currentCheckout: {
                            nik: this.state.nik !== undefined ? this.state.nik : 0,
                            created_at: new Date(),
                            transaction: this.state.deductCandidates,
                            subtotal: this.state.subtotal,
                            cashMoney: this.state.cashMoney,
                            cashChange: this.state.cashChange,
                        }
                    })

                }
                setTimeout(() => {
                    this.setState({ successMessage: undefined, errorMessage: undefined });
                }, 5000);
            });
        }
    }

    handleCheckoutValidation() {
        let isValid = false;
        if (this.state.deductCandidates === undefined || this.state.deductCandidates.length === 0) {
            this.setErrormessage('Barang belanjaan tidak boleh kosong.');
        } else if (this.state.paymentMethod === 0 || this.state.paymentMethod === undefined) {
            this.setErrormessage('Metode pembayaran tidak boleh kosong.' );
        } else if (this.state.nik === undefined || this.state.nik === '') {
            this.setErrormessage('NIK tidak boleh kosong.');
        } else if (this.state.paymentMethod === 1 && this.state.cashMoney === undefined) {
            this.setCashErrormessage('Uang cash tidak boleh kosong utk pembayaran cash.');
        } else {
            isValid = true;
        }

        return isValid;
    }

    handlePreSubmitCredit() {
        // Prevent multiple triggers
        if (this.state.creditActionLoading) {
            return;
        }
        this.setState({ creditActionLoading: true });

        let submitCreditPayload = this.getSubmitCreditPayload();
        this.cleanCommasFromPrices(submitCreditPayload);

        if (this.state.creditValidated) {
            this.handleSubmitCredit(submitCreditPayload);
        } else {
            this.handleValidateCredit(submitCreditPayload);
        }
    }

    cleanCommasFromPrices(submitCreditPayload) {
        if (submitCreditPayload !== undefined
            && submitCreditPayload['amount'] !== undefined
            && submitCreditPayload['total_kredit'] !== undefined
            && typeof submitCreditPayload['amount'] !== 'number'
            && typeof submitCreditPayload['total_kredit'] !== 'number') {
            submitCreditPayload['amount'] = Number(submitCreditPayload['amount'].replace(/,/g, ''));
            submitCreditPayload['total_kredit'] = Number(submitCreditPayload['total_kredit'].replace(/,/g, ''));
        }
    }

    handleSubmitCredit(submitCreditPayload) {
        console.log(process.env.REACT_APP_API_URL + '/' + this.entity)
        // this.CreditDataService.add(submitCreditPayload)
        //     .then((data) => {
        //         if (data.header.status_code !== 200) {
        //             this.setState({ errorMessage: data.header.error_message });
        //         } else {
        //             this.setState({ success: true });
        //         }
        //     })
        //     .catch((err) => {
        //         this.setState({ errorMessage: 'Terjadi kesalahan saat mengajukan kredit.' });
        //     })
        //     .finally(() => {
        //         this.setState({ creditActionLoading: false });
        //         setTimeout(() => {
        //             this.setState({ errorMessage: undefined });
        //         }, 5000);
        //     });
    }

    handleValidateCredit(submitCreditPayload) {
        this.CreditDataService.validate(submitCreditPayload)
            .then((res) => {
                if (res.errorMessage) {
                    this.setState({ errorMessage: res.errorMessage });
                } else {
                    this.setState({
                        creditValidated: true,
                        credits: res.data.kredit_list,
                        cashbonTotal: res.data.cashbon_total,
                        creditApproved: res.data.is_allowed,
                        rejectionReason: res.data.reason_error,
                        installmentPerMonth: res.data.cicilan,
                    }, () => {
                        this.CreditDataService.getMaxCredit()
                            .then((res) => {
                                this.setState({ maxCredit: res.data });
                            })
                    });
                }
                setTimeout(() => {
                    this.setState({ errorMessage: undefined })
                }, 5000);
            })
            .catch(() => {
                this.setState({ errorMessage: 'Terjadi kesalahan saat validasi kredit.' });
            })
            .finally(() => {
                this.setState({ creditActionLoading: false });
            });
    }

    getSubmitCreditPayload() {
        return {
            kredit_name: this.state.kredit_name,
            total_installment: this.state.total_installment,
            nik: this.state.nik,
            amount: this.state.amount,
            total_kredit: this.state.total_kredit,
            is_special_case: this.state.is_special_case,
            category_data: {
                category_id: this.state.category_id,
            },
        };
    }

    resetCreditPage() {
        this.setState({
            creditValidated: false,
            credits: undefined,
            cashbonTotal: undefined,
            kredit_name: '',
            total_installment: '',
            nik: '',
            amount: '',
            total_kredit: '',
            is_special_case: false,
            category_id: '-1',
            success: undefined,
            creditActionLoading: false,
        })
    }

    handleDiscountChanged(e, product) {
        let discountPerQty = e.target.value;
        if (discountPerQty.length > 21) {
            this.setErrormessage('Input angka melebihi batas maksimal sistem.')
        } else {
            discountPerQty = discountPerQty.replace(/,/g, '');
            // Work directly on the referenced product to support both mapped and appended items
            let currentDeductCandidates = Array.isArray(this.state.deductCandidates)
                ? this.state.deductCandidates.slice()
                : [];

            const qty = product.product_stock;
            const discountedPrice = discountPerQty * qty;

            product.discount_per_qty = Number(discountPerQty).toLocaleString();
            product.discounted_price = product.original_sell_price - discountPerQty;
            product.final_sell_price = product.sell_price - discountedPrice;

            let subtotal = this.updateSubtotal(currentDeductCandidates);
            let cashChange = this.recalculateCashChange(subtotal);
            this.setState({
                deductCandidates: currentDeductCandidates,
                subtotal: subtotal,
                cashChange: cashChange,
                checkoutDisabled: false,
            })
            if (product.final_sell_price < 0) {
                this.setErrormessage('Diskon tidak boleh melebihi harga produk.', true);
            } else if (cashChange !== undefined && cashChange < 0) {
                this.setCashErrormessage('Uang cash kurang.');
            }
        }
    }

    setErrormessage(errorMessage, checkoutDisabled) {
        this.setState({
            errorMessage: errorMessage,
            checkoutDisabled: checkoutDisabled,
        })
        setTimeout(() => {
            this.setState({ errorMessage: undefined });
        }, 5000);
    }

    setCashErrormessage(cashErrorMessage, checkoutDisabled = false) {
        this.setState({
            cashErrorMessage: cashErrorMessage,
            checkoutDisabled: checkoutDisabled,
        })
        setTimeout(() => {
            this.setState({ cashErrorMessage: undefined });
        }, 5000);
    }

    handleResponse(data, successMessage) {
        if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
                return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.props.toggleModal()
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentProduct: {} })
            this.props.fetchData()
        }
    }

    handleChangeOnCash(e) {
        this.setState({ checkoutDisabled: false, errorMessage: undefined, cashErrorMessage: undefined });

        let digits = String(e.target.value).replace(/[^0-9]/g, '');
        if (digits.length > 21) {
            this.setErrormessage('Input angka melebihi batas maksimal sistem.');
        } else if (digits === '') {
            // Let the cashier clear the field; formatting '' would pin it to "0".
            this.setState({ cashMoney: '', cashChange: undefined });
        } else {
            let cashChange = parseAmount(digits) - this.getDisplaySubtotal();

            this.setState({
                cashChange: cashChange,
                cashMoney: formatAmount(digits),
            }, () => {
                if (cashChange < 0) {
                    this.setCashErrormessage('Uang cash kurang.');
                }
            })
        }
    }

    onReset() {
        window.location.reload();
    }

    handlePrint() {
        localStorage.setItem('currentCheckout', JSON.stringify(this.state.currentCheckout));

        var myWindow= window.open('/print/checkout-receipt');;
        myWindow.focus();
        myWindow.print();
    }

    handleProductStockInputChanged(e, product) {
        const value = e.target.value;
        this.setState((prevState) => ({
            stockInputs: { ...prevState.stockInputs, [product.product_id]: value },
        }));
    }

    clearStockInput(productId) {
        this.setState((prevState) => {
            const stockInputs = { ...prevState.stockInputs };
            delete stockInputs[productId];
            return { stockInputs };
        });
    }

    commitProductStockChange(product) {
        const rawValue = this.state.stockInputs[product.product_id];
        if (rawValue === undefined) {
            return;
        }

        const newStock = parseInt(rawValue, 10);
        this.clearStockInput(product.product_id);

        if (isNaN(newStock) || newStock < 0 || newStock === product.product_stock) {
            return;
        }

        if (newStock < product.product_stock) {
            let diff = product.product_stock - newStock;
            for (let i = 0; i < diff; i++) {
                this.cancelDeductStock(product);
            }
        } else {
            this.ProductDataService.getById(product.product_id).then((data) => {
                if (data.product === undefined) {
                    return;
                }
                let diff = newStock - product.product_stock;
                let available = data.product.stock_warehouse - product.product_stock;
                if (available < diff) {
                    this.setErrormessage('Stok tidak tersedia lagi.', false);
                    return;
                }

                let currentDeductCandidates = this.state.deductCandidates.slice();
                let existingCandidate = currentDeductCandidates[product.product_id];
                if (existingCandidate === undefined) {
                    return;
                }
                let discountPerQty = Number(existingCandidate.discount_per_qty.replace(/,/g, ''));
                existingCandidate.product_stock = newStock;
                existingCandidate.sell_price = data.product.sell_price * newStock;
                existingCandidate.final_sell_price = (data.product.sell_price - discountPerQty) * newStock;

                this.updateCandidateDetails(currentDeductCandidates);
            });
        }
    }

    render() {
        const isOpen = this.state.emoneyCardOpen;

        const buttonWidth = isOpen ? '40px' : '150px';
        const buttonBorderRadius = isOpen ? '50%' : '20px';
        const buttonRight = isOpen ? '365px' : '15px';
        const buttonStyle = {
            position: 'fixed',
            zIndex: 1001,
            right: buttonRight,
            marginRight: '0.8rem',
            top: '100px',
            transition: 'all 0.3s ease-in-out',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
            width: buttonWidth,
            height: '40px',
            borderRadius: buttonBorderRadius,
            display: 'flex',
            alignItems: 'center',
            justifyContent: isOpen ? 'center' : 'space-around',
            padding: isOpen ? '0' : '0 10px',
            cursor: 'pointer',
            backgroundColor: '#fff',
            color: '#5e72e4',
            border: '1px solid #dee2e6',
        };
        return (
            <>
                <div style={{
                    position: 'relative',
                    // Locked POS content is short, so stretch it to the viewport (minus
                    // navbar and footer) to keep the greyout reaching down to the footer.
                    minHeight: this.state.cashierIsOpen ? undefined : 'calc(120vh - 180px)',
                }}>
                {!this.state.cashierIsOpen && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            // The layout renders the footer after this page, so overshoot
                            // the wrapper by roughly the footer height to cover it too.
                            bottom: '-6.5rem',
                            zIndex: 1002,
                            backgroundColor: 'rgba(222, 226, 230, 0.94)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <div className="px-4">
                            <i className="fas fa-lock fa-3x text-muted mb-3" />
                            <h2 className="text-muted">Kasir belum dibuka</h2>
                            {this.isCashier() ? (
                                <>
                                    <p className="text-muted mb-4">
                                        Buka kasir terlebih dahulu untuk mulai bertransaksi.
                                    </p>
                                    <Button
                                        color="primary"
                                        size="lg"
                                        type="button"
                                        disabled={this.state.cashierActionLoading || this.state.cashierLoading}
                                        onClick={() => this.handleCashierStatusChange()}
                                    >
                                        {this.state.cashierActionLoading ? 'Memproses…' : 'OPEN'}
                                    </Button>
                                </>
                            ) : (
                                <p className="text-muted mb-0">
                                    Hanya user dengan role kasir yang dapat membuka kasir.
                                </p>
                            )}
                            {this.state.cashierErrorMessage && (
                                <Alert color="danger" className="mt-4 mb-0 py-2 px-3">
                                    {this.state.cashierErrorMessage}
                                </Alert>
                            )}
                        </div>
                    </div>
                )}
                <PointOfSalesHeader
                    tabs={this.state.tabs}
                    toggleNavs={this.toggleNavs}
                />
                {/* Page content */}
                <TabContent activeTab={"tabs" + this.state.tabs}>
                    <TabPane tabId="tabs1">
                        <Container className="mt--7" fluid>
                            <Row>
                                <Col className="order-xl-1" xl="12">
                                    {this.state.cashierIsOpen && (
                                        <Card className="shadow mb-4">
                                            <CardBody className="py-3">
                                                <Row className="align-items-center">
                                                    <Col md="8">
                                                        <div className="d-flex align-items-center flex-wrap">
                                                            <Badge color="success" pill className="px-3 py-2 mr-3">
                                                                <span style={{ fontSize: '0.9rem' }}>
                                                                    <i className="fas fa-lock-open mr-2" />
                                                                    Kasir Terbuka
                                                                </span>
                                                            </Badge>
                                                            {this.state.cashierSession?.OpenAt && (
                                                                <span className="text-muted text-sm mr-3">
                                                                    Dibuka {this.formatSessionTime(this.state.cashierSession.OpenAt)}
                                                                </span>
                                                            )}
                                                            {!this.state.cashierIsSessionOwner && (
                                                                <span className="text-warning text-sm">
                                                                    <i className="fas fa-info-circle mr-1" />
                                                                    Kasir dibuka oleh user lain
                                                                </span>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md="4" className="text-md-right mt-3 mt-md-0">
                                                        {this.isCashier() && (
                                                            <Button
                                                                color="danger"
                                                                type="button"
                                                                disabled={this.state.cashierActionLoading || this.state.cashierLoading}
                                                                onClick={() => this.handleCashierStatusChange()}
                                                            >
                                                                {this.state.cashierActionLoading ? 'Memproses…' : 'CLOSE'}
                                                            </Button>
                                                        )}
                                                    </Col>
                                                </Row>
                                                {this.state.cashierErrorMessage && (
                                                    <Alert color="danger" className="mt-3 mb-0 py-2 px-3">
                                                        {this.state.cashierErrorMessage}
                                                    </Alert>
                                                )}
                                            </CardBody>
                                        </Card>
                                    )}

                                    {/* Search Form */}
                                    <Card className="shadow">
                                        <CardHeader className="border-0">
                                            <Row>
                                                <Col md="12" className="mt-3 align-items-right">
                                                    {this.state.successMessage && (
                                                        <Col xs="12" className="mt-5">
                                                            <Alert color="success">
                                                                {this.state.successMessage}
                                                            </Alert>
                                                        </Col>
                                                    )}
                                                    {this.state.errorMessage && (
                                                        <Alert color="danger">
                                                            {this.state.errorMessage}
                                                        </Alert>
                                                    )}
                                                </Col>
                                                <Col xs="12" className="mt-3 align-items-right">
                                                    <FormGroup>
                                                        <InputGroup className="input-group-alternative mb-4 flex-nowrap">
                                                            <InputGroupAddon addonType="prepend">
                                                                <ButtonGroup>
                                                                    <Button
                                                                        type="button"
                                                                        color="primary"
                                                                        outline={this.state.searchId !== 'nama'}
                                                                        onClick={() => this.setSearchId('nama')}
                                                                    >
                                                                        Nama Produk
                                                                    </Button>
                                                                    <Button
                                                                        type="button"
                                                                        color="primary"
                                                                        outline={this.state.searchId !== 'barcode'}
                                                                        onClick={() => this.setSearchId('barcode')}
                                                                    >
                                                                        Barcode
                                                                    </Button>
                                                                </ButtonGroup>
                                                            </InputGroupAddon>
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className={this.state.searchId === 'barcode' ? 'ni ni-tag' : 'ni ni-zoom-split-in'} />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input
                                                                className="form-control-alternative"
                                                                placeholder={this.state.searchId === 'barcode' ? 'Scan atau ketik barcode' : 'Search produk'}
                                                                onChange={(e) => this.handleSearch(e)}
                                                                onKeyUp={this.onKeyUp.bind(this)}
                                                                name="searchValue"
                                                                value={this.state.searchValue}
                                                                type="text"
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                    </Card>

                                    {/* Product List */}
                                    <Card className="shadow mt-4 mb-1">
                                        {this.state.products != null && this.state.products.filter(product => product).length > 0 && (
                                            <Products
                                                products={this.state.products}
                                                toggleModal={this.toggleModal}
                                                formModal={this.state.formModal}
                                                formType={this.state.formType}
                                                setSuccessMessage={this.setSuccessMessage}
                                                fetchData={this.fetchData.bind(this)}
                                                isPOS={true}
                                                addToCart={this.addToCart.bind(this)}
                                            />
                                        )}
                                    </Card>
                                    {this.state.deductCandidates?.length > 0 && (
                                        <Card className="card-profile shadow">
                                            {/* <CardHeader>
                                        </CardHeader> */}
                                            <CardBody>
                                                <Table className="align-items-center table-flush table-borderless" responsive>
                                                    <thead>
                                                    <th>Nama produk</th>
                                                    <th>Qty</th>
                                                    <th>Harga per qty</th>
                                                    <th>Diskon per qty</th>
                                                    <th>Total harga</th>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.deductCandidates && this.state.deductCandidates.map((product) => (
                                                        <tr>
                                                            <th>
                                                                {product.product_name}
                                                            </th>
                                                            <td>
                                                                <Input placeholder=""
                                                                       name="product_stock"
                                                                       className="form-control-alternative"
                                                                       disabled={this.state.currentCheckout !== undefined || product.product_price !== undefined}
                                                                       size="md"
                                                                       value={this.state.stockInputs[product.product_id] !== undefined ? this.state.stockInputs[product.product_id] : product.product_stock}
                                                                       onChange={(e) => this.handleProductStockInputChanged(e, product)}
                                                                       onBlur={() => this.commitProductStockChange(product)}
                                                                       onKeyUp={(e) => {
                                                                           const charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
                                                                           if (charCode === 13) {
                                                                               this.commitProductStockChange(product);
                                                                           }
                                                                           this.onKeyUp(e);
                                                                       }}
                                                                       type="number" />
                                                            </td>
                                                            <td>
                                                                <NumberFormat
                                                                    value={product.original_sell_price}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={'Rp.'} suffix={',00'} />
                                                            </td>
                                                            <td>
                                                                <Input placeholder="Diskon per qty"
                                                                       name="discounted_price_per_qty"
                                                                       className="form-control-alternative"
                                                                       disabled={this.state.currentCheckout !== undefined}
                                                                       size="sm"
                                                                       value={product.discount_per_qty}
                                                                       onChange={(e) => this.handleDiscountChanged(e, product)}
                                                                       onKeyUp={this.onKeyUp.bind(this)}
                                                                       type="text" />
                                                            </td>
                                                            <td>
                                                                <NumberFormat
                                                                    value={this.getEffectiveFinalSellPrice(product)}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={'Rp.'} suffix={',00'} />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <th></th>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            <h2 className="">Subtotal</h2>
                                                        </td>
                                                        <td>
                                                            <h2 className="">
                                                                <NumberFormat
                                                                    value={this.getDisplaySubtotal()}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={'Rp.'} suffix={',00'} />
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr className="table-borderless">
                                                        <th></th>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            <h2>Metode pembayaran</h2>
                                                        </td>
                                                        <td>
                                                            <h2 className="">
                                                                <Input placeholder="Metode pembayaran"
                                                                       onKeyUp={this.onKeyUp.bind(this)}
                                                                       className="form-control-alternative"
                                                                       name="paymentMethod"
                                                                       size="sm"
                                                                       onChange={this.handleInputChanged.bind(this)}
                                                                       disabled={this.state.currentCheckout !== undefined}
                                                                       value={this.state.paymentMethod}
                                                                       type="select" >
                                                                    <option value="1">Cash</option>
                                                                    <option value="2">Cashbon</option>
                                                                </Input>
                                                            </h2>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    {this.state.paymentMethod !== 2 && (
                                                        <tr className="table-borderless">
                                                            <th></th>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <h2>Uang cash</h2>
                                                            </td>
                                                            <td>
                                                                <h2 className="">
                                                                    <Input placeholder="Uang cash"
                                                                           onKeyUp={this.onKeyUp.bind(this)}
                                                                           className="form-control-alternative"
                                                                           name="cash_money"
                                                                           disabled={this.state.currentCheckout !== undefined}
                                                                           size="sm"
                                                                           value={this.state.cashMoney}
                                                                           onChange={this.handleChangeOnCash.bind(this)}
                                                                           type="text" />
                                                                </h2>
                                                                {this.state.cashErrorMessage && (
                                                                    <Alert color="danger" className="mt-2 py-2 px-3 mb-0">
                                                                        {this.state.cashErrorMessage}
                                                                    </Alert>
                                                                )}
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    )}
                                                    {this.getDisplayCashChange() > 0 && (
                                                        <tr className="table-borderless">
                                                            <th></th>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <h2 className="">Kembalian</h2>
                                                            </td>
                                                            <td>
                                                                <h2 className="">
                                                                    <NumberFormat
                                                                        value={this.getDisplayCashChange()}
                                                                        displayType={'text'}
                                                                        thousandSeparator={true}
                                                                        prefix={'Rp.'} suffix={',00'} />
                                                                </h2>
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    )}
                                                    {/* {this.state.paymentMethod == 2 && ( */}
                                                        <tr className="table-borderless">
                                                            <th></th>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <h2>NIK <sup className="text-red text-sm">*</sup></h2>
                                                            </td>
                                                            <td>
                                                                <h2 className="">
                                                                    <Input
                                                                        onKeyUp={this.onKeyUp.bind(this)}
                                                                        className="form-control-alternative"
                                                                        name="nik"
                                                                        disabled={this.state.currentCheckout !== undefined}
                                                                        value={this.state.nik}
                                                                        onChange={this.handleInputChanged.bind(this)}
                                                                        placeholder="NIK yang mengajukan"
                                                                        type="text"
                                                                        required
                                                                    />
                                                                </h2>
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                        {this.state.namaKaryawan !== '' && this.state.namaKaryawan !== undefined && (
                                                        <tr className="table-borderless">
                                                            <th></th>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <h2>Nama karyawan</h2>
                                                            </td>
                                                            <td>
                                                                <h2
                                                                    className="mb-0"
                                                                    style={{
                                                                        // Cap the intrinsic width so a long name wraps
                                                                        // instead of widening the column.
                                                                        maxWidth: '220px',
                                                                        whiteSpace: 'normal',
                                                                        wordBreak: 'break-word',
                                                                    }}
                                                                >
                                                                    {this.state.namaKaryawan}
                                                                </h2>
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    )}
                                                    {/* )} */}
                                                    {this.getPotentialLoyaltyPoints() > 0 && (
                                                        <tr className="table-borderless">
                                                            <th></th>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <h2 className="text-muted">Potensi poin loyalitas</h2>
                                                            </td>
                                                            <td>
                                                                <Badge color="success" pill className="px-3 py-2">
                                                                    <span style={{ fontSize: '0.95rem' }}>
                                                                        <i class="fa fa-star" aria-hidden="true"></i> {this.getPotentialLoyaltyPoints().toLocaleString()} poin
                                                                    </span>
                                                                </Badge>
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    )}
                                                    </tbody>
                                                </Table>
                                                <div className="btn-wrapper text-right">
                                                    <div>
                                                        {this.state.currentCheckout !== undefined && (
                                                            <Button
                                                                className="my-4"
                                                                color="info"
                                                                type="button"
                                                                onClick={() => this.handlePrint()}>
                                                                Cetak</Button>
                                                        )}
                                                        {!this.state.checkoutDisabled && !this.isCashShort() && this.state.currentCheckout === undefined && (
                                                            <Button
                                                                className="my-4"
                                                                className="form-class-alternative"
                                                                color="primary"
                                                                type="button"
                                                                onClick={() => this.handleCheckout()}
                                                            >
                                                                Checkout
                                                            </Button>
                                                        )}
                                                        <Button
                                                            className="my-4"
                                                            className="form-class-alternative"
                                                            color="danger"
                                                            type="button"
                                                            onClick={() => this.onReset()}
                                                        >
                                                            Reset
                                                        </Button>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Col>
                            </Row>
                        </Container>

                        <div
                            style={{
                                position: 'fixed',
                                zIndex: 1000,
                                top: '100px',
                                right: this.state.emoneyCardOpen ? '15px' : '-350px',
                                width: '350px',
                                transition: 'right 0.3s ease-in-out',
                                height: 'calc(100vh - 120px)',
                            }}
                        >
                            <Card className="shadow h-100 d-flex flex-column">
                                <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                    <h3 className="mb-0">E-Money Products</h3>
                                    <Button
                                        color="secondary"
                                        size="sm"
                                        onClick={this.toggleEmoneyCard}
                                    >
                                        {this.state.emoneyCardOpen ? '< Minimize' : 'E-Money >'}
                                    </Button>
                                </CardHeader>
                                <CardBody className="p-0 overflow-y-auto flex-grow-1">
                                    {this.state.emoneyLoading && (
                                        <div className="text-center py-5">
                                            <Spinner color="primary" />
                                            <div className="mt-2">Memuat E-Money…</div>
                                        </div>
                                    )}

                                    {!this.state.emoneyLoading && this.state.emoneyProducts && this.state.emoneyProducts.map((product) => (
                                        <Card
                                            key={product.product_id}
                                            className={`shadow mb-3 mx-3 ${this.state.selectedEmoneyId === product.product_id ? 'bg-gradient-warning' : ''}`}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => this.handleEmoneyCardClick(product.product_id)}
                                        >
                                            <CardBody className="py-3 px-3">
                                                <div className="text-center">
                                                    <h5 className={`h5 mb-1 ${this.state.selectedEmoneyId === product.product_id ? 'text-white' : ''}`}>
                                                        {product.product_name}
                                                    </h5>
                                                    <div className={`text-sm font-weight-300 ${this.state.selectedEmoneyId === product.product_id ? 'text-white' : ''}`}>
                                                        <i className="fa-solid fa-barcode mr-2"></i>
                                                        {product.product_barcode}
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    ))}

                                    {!this.state.emoneyLoading && (!this.state.emoneyProducts || this.state.emoneyProducts.length === 0) && (
                                        <div className="text-center py-4">
                                            <p className="lead">{this.state.emoneyError ? this.state.emoneyError : 'No E-Money products available'}</p>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </div>
                    </TabPane>
                    <TabPane tabId="tabs2">
                        <Container className="mt--7" fluid>
                            <Row>
                                <Col className="order-xl-2 mb-5 mb-xl-0" xl="12">
                                    <Card className="bg-secondary shadow">
                                        <CardHeader className="bg-white border-0">
                                            <Row className="align-items-center">
                                                <Col xs="8">
                                                    <h3 className="mb-0">Form pengajuan</h3>
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        <CardBody>
                                            <Form>
                                                <h6 className="heading-small text-muted mb-4">
                                                    Informasi pengajuan
                                                </h6>
                                                <div className="pl-lg-4">
                                                    <Row>
                                                        <Col lg="12">
                                                            {this.state.errorMessage && (
                                                                <Alert color="danger">
                                                                    {this.state.errorMessage}
                                                                </Alert>
                                                            )}
                                                        </Col>
                                                        <Col lg="4">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-username"
                                                                >
                                                                    Kredit yang diajukan
                                                                </label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    name="kredit_name"
                                                                    value={this.state.kredit_name}
                                                                    disabled={this.state.success}
                                                                    onKeyUp={this.onKeyUpKredit.bind(this)}
                                                                    onChange={this.handleInputChanged.bind(this)}
                                                                    placeholder="Nama Barang/pinjaman yang diajukan"
                                                                    type="text"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="4">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-username"
                                                                >
                                                                    Kategori kredit
                                                                </label>
                                                                <Input placeholder="Kategori kredit"
                                                                       name="category_id"
                                                                       onKeyUp={this.onKeyUpKredit.bind(this)}
                                                                       value={this.state.category_id}
                                                                       disabled={this.state.success}
                                                                       onChange={this.handleInputChanged.bind(this)}
                                                                       type="select" >
                                                                    <option selected value='-1' disabled>Kategori kredit</option>
                                                                    {this.state.creditCategories?.length > 0 && this.state.creditCategories.filter(cateory => cateory).map((category) => (
                                                                        <option value={category.category_id}>{category.category_name}</option>
                                                                    ))}
                                                                </Input>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="4">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-email"
                                                                >
                                                                    Nominal pinjaman
                                                                </label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    name="amount"
                                                                    onKeyUp={this.onKeyUpKredit.bind(this)}
                                                                    disabled={this.state.success}
                                                                    value={this.state.amount}
                                                                    onChange={this.handleInputChanged.bind(this)}
                                                                    placeholder="Nominal yang diajukan"
                                                                    type="text"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="4">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-email"
                                                                >
                                                                    Total pinjaman
                                                                </label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    name="total_kredit"
                                                                    onKeyUp={this.onKeyUpKredit.bind(this)}
                                                                    disabled={this.state.success}
                                                                    value={this.state.total_kredit}
                                                                    onChange={this.handleInputChanged.bind(this)}
                                                                    placeholder="Total pinjaman yang dipinjamkan"
                                                                    type="text"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="4">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-first-name"
                                                                >
                                                                    Tenor cicilan
                                                                </label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    name="total_installment"
                                                                    onKeyUp={this.onKeyUpKredit.bind(this)}
                                                                    value={this.state.total_installment}
                                                                    disabled={this.state.success}
                                                                    onChange={this.handleInputChanged.bind(this)}
                                                                    placeholder="Tenor cicilan dalam hitungan bulan"
                                                                    type="number"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg="4">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="input-last-name"
                                                                >
                                                                    NIK
                                                                </label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    name="nik"
                                                                    onKeyUp={this.onKeyUpKredit.bind(this)}
                                                                    value={this.state.nik}
                                                                    disabled={this.state.success}
                                                                    onChange={this.handleInputChanged.bind(this)}
                                                                    placeholder="NIK yang mengajukan"
                                                                    type="text"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg="4">
                                                            <FormGroup>
                                                                <div className="custom-control custom-control-alternative custom-radio mb-3"></div>
                                                                <div className="custom-control custom-control-alternative custom-radio mb-3">
                                                                    <input
                                                                        className="custom-control-input"
                                                                        id="customCheck5"
                                                                        value={this.state.is_special_case}
                                                                        disabled={this.state.success}
                                                                        onChange={this.handleInputChanged.bind(this)}
                                                                        name="is_special_case"
                                                                        type="checkbox"
                                                                    />
                                                                    <label className="custom-control-label" htmlFor="customCheck5">
                                                                        Special case
                                                                    </label>
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <hr className="my-4" />
                                                {this.state.creditValidated && (
                                                    <div>
                                                        <h6 className="heading-small text-muted mb-4">
                                                            Riwayat kredit pemohon
                                                        </h6>
                                                        <div className="pl-lg-4">
                                                            <Table className="align-items-center table-flush" responsive>
                                                                <thead className="thead-light">
                                                                <tr>
                                                                    <th scope="col">Kredit</th>
                                                                    <th scope="col">Nominal pinjaman</th>
                                                                    <th scope="col">Total pinjaman</th>
                                                                    <th scope="col">Cicilan per bulan</th>
                                                                    <th scope="col">Tenor pinjaman</th>
                                                                    <th scope="col">Tenor pinjaman berjalan</th>
                                                                    <th scope="col" />
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {this.state.credits && this.state.credits.map((credit) => (
                                                                    <tr>
                                                                        <th>
                                                                            {credit.kredit_name}
                                                                        </th>
                                                                        <td>
                                                                            <NumberFormat
                                                                                value={credit.amount}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                                prefix={'Rp.'} suffix={',00'} />
                                                                        </td>
                                                                        <td>
                                                                            <NumberFormat
                                                                                value={credit.total_kredit}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                                prefix={'Rp.'} suffix={',00'} />
                                                                        </td>
                                                                        <td>
                                                                            <NumberFormat
                                                                                value={credit.cicilan}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                                prefix={'Rp.'} suffix={',00'} />
                                                                        </td>
                                                                        <td>
                                                                            {credit.total_installment}
                                                                        </td>
                                                                        <td>
                                                                            {credit.current_installment}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                        <hr className="my-4" />
                                                        <h6 className="heading-small text-muted mb-4">
                                                            Validasi pengajuan pemohon
                                                        </h6>
                                                        <div className="pl-lg-4">
                                                            <Table className="align-items-center table-flush" responsive>
                                                                <tbody>
                                                                <tr>
                                                                    <th>NIK</th>
                                                                    <td>{this.state.nik}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Nama</th>
                                                                    <td>{this.state.namaKaryawan}</td>
                                                                </tr>
                                                                {/* <tr>
                                                                <th>Total cicilan berjalan saat ini</th>
                                                                <td>
                                                                    <NumberFormat
                                                                        value={this.state.cashbonTotal}
                                                                        displayType={'text'}
                                                                        thousandSeparator={true}
                                                                        prefix={'Rp.'} suffix={',00'} />
                                                                </td>
                                                            </tr> */}
                                                                <tr>
                                                                    <th>Total cashbon saat ini</th>
                                                                    <td>
                                                                        <NumberFormat
                                                                            value={this.state.cashbonTotal}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            prefix={'Rp.'} suffix={',00'} />
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Nominal pinjaman</th>
                                                                    <td>
                                                                        <NumberFormat
                                                                            value={this.state.amount}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            prefix={'Rp.'} suffix={',00'} />
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Total kredit</th>
                                                                    <td>
                                                                        <NumberFormat
                                                                            value={this.state.total_kredit}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            prefix={'Rp.'} suffix={',00'} />
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Tenor cicilan</th>
                                                                    <td>{this.state.total_installment} bulan</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Cicilan per bulan</th>
                                                                    <td>
                                                                        <NumberFormat
                                                                            value={this.state.installmentPerMonth}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            prefix={'Rp.'} suffix={',00'} />
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Cicilan maksimal per bulan</th>
                                                                    <td>
                                                                        <NumberFormat
                                                                            value={this.state.maxCredit}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            prefix={'Rp.'} suffix={',00'} />
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Status</th>
                                                                    <td>
                                                                        <Badge
                                                                            color={this.state.creditApproved ? "success" : "danger"}
                                                                        >
                                                                            {this.state.creditApproved ? 'Disetujui' : 'Ditolak'}
                                                                        </Badge>
                                                                    </td>
                                                                </tr>
                                                                {!this.state.creditApproved && (
                                                                    <tr>
                                                                        <th>Alasan penolakkan</th>
                                                                        <td>{this.state.rejectionReason}</td>
                                                                    </tr>
                                                                )}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="btn-wrapper text-right">
                                                    {this.state.success && (
                                                        <Col xs="12" className="mt-5">
                                                            <Alert color="success">
                                                                <b>Pengajuan kredit berhasil.</b> <a href="#" onClick={() => this.resetCreditPage()}>Buat pengajuan baru</a>
                                                            </Alert>
                                                        </Col>
                                                    )}
                                                    {!this.state.success && (
                                                        <div>
                                                            <Button
                                                                className="my-4"
                                                                color="danger"
                                                                type="button"
                                                                onClick={() => this.resetCreditPage()}
                                                            >
                                                                Reset
                                                            </Button>
                                                            <Button
                                                                className="my-4"
                                                                color="primary"
                                                                disabled={(this.state.creditValidated && !this.state.creditApproved) || this.state.creditActionLoading}
                                                                type="button"
                                                                onClick={() => this.handlePreSubmitCredit()}
                                                            >
                                                                {this.state.creditActionLoading ? 'Memproses…' : (this.state.creditValidated ? 'Ajukan' : 'Validasi')}
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </TabPane>
                </TabContent>
                </div>

                {this.state.cashierIsOpen && (
                    <div
                        onClick={this.toggleEmoneyCard}
                        style={buttonStyle}
                        aria-label={isOpen ? 'Minimize E-Money Panel' : 'Open E-Money Panel'}
                    >
                        <i className={`fas fa-chevron-${isOpen ? 'right' : 'left'}`}></i>
                        {!isOpen && <span className="ml-1 font-weight-bold">E-Money</span>}
                    </div>
                )}
                <div
                    style={{
                        position: 'fixed',
                        zIndex: 1000,
                        top: '100px',
                        right: this.state.emoneyCardOpen ? '15px' : '-350px',
                        width: '350px',
                        transition: 'right 0.3s ease-in-out',
                        height: 'calc(100vh - 120px)',
                    }}
                >
                    <Card className="shadow h-100 d-flex flex-column">
                        <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                            <h3 className="mb-0">E-Money Products</h3>
                        </CardHeader>
                        <CardBody className="p-0 overflow-y-auto flex-grow-1">
                            {this.state.emoneyLoading && (
                                <div className="text-center py-5">
                                    <Spinner color="primary" />
                                    <div className="mt-2">Memuat E-Money…</div>
                                </div>
                            )}

                            {!this.state.emoneyLoading && this.state.emoneyProducts && this.state.emoneyProducts.map((product) => (
                                <Card
                                    key={product.product_id}
                                    className={`shadow mb-3 mx-3 ${this.state.clickedEmoneyId === product.product_id ? 'bg-gradient-red' : ''}`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        this.setState({ clickedEmoneyId: product.product_id });
                                        setTimeout(() => this.setState({ clickedEmoneyId: null }), 150);
                                        this.handleEmoneyCardClick(product.product_id);
                                    }}
                                >
                                    <CardBody className="py-3 px-3">
                                        <div className="text-center">
                                            <h5 className={`h5 mb-1`}>
                                                {product.product_name}
                                            </h5>
                                            <div className={`text-sm font-weight-300`}>
                                                <i className="fa-solid fa-barcode mr-2"></i>
                                                {product.product_barcode}
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            ))}

                            {!this.state.emoneyLoading && (!this.state.emoneyProducts || this.state.emoneyProducts.length === 0) && (
                                <div className="text-center py-4">
                                    <p className="lead">{this.state.emoneyError ? this.state.emoneyError : 'No E-Money products available'}</p>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </div>
                <Modal
                    className="modal-dialog-centered"
                    isOpen={this.state.emoneyPriceModal}
                    toggle={this.toggleEmoneyPriceModal}
                >
                    <div className="modal-body p-0">
                        <Card className="bg-secondary shadow border-0">
                            <CardHeader className="bg-transparent">
                                <div className="text-muted text-center mt-2 mb-3">
                                    <h3 className="mb-0">Input Harga E-Money</h3>
                                </div>
                            </CardHeader>
                            <CardBody className="px-lg-5 py-lg-5">
                                {this.state.errorMessage && (
                                    <Alert color="danger">
                                        {this.state.errorMessage}
                                    </Alert>
                                )}
                                {this.state.selectedEmoney && (
                                    <div className="text-center mb-4">
                                        <h4>{this.state.selectedEmoney.product_name}</h4>
                                        <p className="text-muted">
                                            <i className="fa-solid fa-barcode mr-2"></i>
                                            {this.state.selectedEmoney.product_barcode}
                                        </p>
                                    </div>
                                )}
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-price"
                                    >
                                        Harga
                                    </label>
                                    <Input
                                        placeholder="Masukkan harga"
                                        className="form-control-alternative"
                                        name="emoneyPrice"
                                        id="input-price"
                                        value={this.state.emoneyPrice}
                                        onChange={this.handleEmoneyPriceChange}
                                        type="text"
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-original-price"
                                    >
                                        Harga Beli
                                    </label>
                                    <Input
                                        placeholder="Masukkan harga beli"
                                        className="form-control-alternative"
                                        name="original_price"
                                        id="input-original-price"
                                        value={this.state.emoneyOriginalPrice}
                                        onChange={this.handleEmoneyOriginalPriceChange}
                                        type="text"
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <div className="btn-wrapper text-right">
                                        <Button
                                            className="my-4"
                                            color="secondary"
                                            type="button"
                                            onClick={this.toggleEmoneyPriceModal}
                                        >
                                            Batal
                                        </Button>
                                        <Button
                                            className="my-4"
                                            color="primary"
                                            type="button"
                                            onClick={this.handleEmoneyPriceSubmit}
                                        >
                                            Simpan
                                        </Button>
                                    </div>
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </div>
                </Modal>
                <Modal
                    centered
                    isOpen={this.state.cashierSummaryModal}
                    toggle={this.toggleCashierSummaryModal}
                >
                    <div className="modal-body p-0">
                        <Card className="shadow border-0 mb-0">
                            <CardHeader className="bg-gradient-success border-0">
                                <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                        <h6 className="text-uppercase text-white ls-1 mb-1 opacity-8">
                                            Sesi kasir selesai
                                        </h6>
                                        <h2 className="text-white mb-0">
                                            <i className="fas fa-lock mr-2" />
                                            Ringkasan Tutup Kasir
                                        </h2>
                                    </div>
                                    <button
                                        aria-label="Close"
                                        className="close text-white"
                                        type="button"
                                        onClick={this.toggleCashierSummaryModal}
                                    >
                                        <span aria-hidden={true}>&times;</span>
                                    </button>
                                </div>
                            </CardHeader>
                            <CardBody className="px-4 py-4">
                                <div className="text-center mb-4">
                                    <div className="text-uppercase text-muted text-xs ls-1 mb-1">
                                        Total penjualan
                                    </div>
                                    <div className="h1 mb-0" style={{ wordBreak: 'break-word' }}>
                                        <NumberFormat
                                            value={this.state.cashierSummary?.TotalSales}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'Rp.'} />
                                    </div>
                                </div>

                                <Row className="mb-4">
                                    <Col xs="6">
                                        <div className="border rounded px-3 py-3 h-100">
                                            <div className="text-uppercase text-muted text-xs ls-1 mb-1">
                                                <i className="fas fa-money-bill-wave mr-1" />
                                                Cash
                                            </div>
                                            <div className="h4 mb-0" style={{ wordBreak: 'break-word' }}>
                                                <NumberFormat
                                                    value={this.state.cashierSummary?.TotalCash}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={'Rp.'} />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs="6">
                                        <div className="border rounded px-3 py-3 h-100">
                                            <div className="text-uppercase text-muted text-xs ls-1 mb-1">
                                                <i className="fas fa-file-invoice-dollar mr-1" />
                                                Cashbon
                                            </div>
                                            <div className="h4 mb-0" style={{ wordBreak: 'break-word' }}>
                                                <NumberFormat
                                                    value={this.state.cashierSummary?.TotalCashbon}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={'Rp.'} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                <div className="d-flex justify-content-between align-items-center border-top pt-3">
                                    <span className="text-uppercase text-muted text-xs ls-1">
                                        Total profit
                                    </span>
                                    <span className="h3 mb-0 text-success">
                                        <NumberFormat
                                            value={this.state.cashierSummary?.TotalProfit}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'Rp.'} />
                                    </span>
                                </div>

                                <div className="d-flex justify-content-between text-xs text-muted mt-3">
                                    <span>
                                        Buka {this.formatSessionTime(this.state.cashierSummary?.OpenAt)}
                                    </span>
                                    <span>
                                        Tutup {this.formatSessionTime(this.state.cashierSummary?.CloseAt)}
                                    </span>
                                </div>

                                <Button
                                    className="mt-4"
                                    color="primary"
                                    block
                                    type="button"
                                    onClick={this.toggleCashierSummaryModal}
                                >
                                    Tutup
                                </Button>
                            </CardBody>
                        </Card>
                    </div>
                </Modal>
            </>
        );
    }
}

export default PointOfSales;
